import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';

type State = {
  isWelcomeGenAITooltipOpen: boolean;
};

const initialState: State = {
  isWelcomeGenAITooltipOpen: false
};

export const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    setIsOpenWelcomeGenAITooltip: (state, action: PayloadAction<boolean>) => {
      state.isWelcomeGenAITooltipOpen = action.payload;
    }
  }
});

export const selectIsWelcomeGenAITooltipOpen = createSelector(
  (state: RootState) => state.alerts,
  (alertsState: State) => alertsState.isWelcomeGenAITooltipOpen
);

export const { setIsOpenWelcomeGenAITooltip } = alertsSlice.actions;

export default alertsSlice.reducer;
